import { Component, OnInit, signal } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

import moment from 'moment';
import { DashboardStats, DashboardStatsComponent } from './components/dashboard-stats/dashboard-stats.component';
import { RequisitionFilterComponent } from './components/requisition-filter/requisition-filter.component';
import { RequisitionTableComponent } from './components/requisition-table/requisition-table.component';
import { LabmoduleService } from './../services/labmodule.service';
import { LabDashboardHeaderComponent } from './components/ladashboard-header/ladashboard-header.component';
import { AuthService } from '../services/auth.service';
import { PatientOnboardDialogComponent } from './components/patient-onboard-dialog/patient-onboard-dialog.component';
import { StatusUpdateDialogComponent } from './components/status-update-dialog/status-update-dialog.component';
import { PatientSelectionDialogComponent } from './components/patient-selection-dialog/patient-selection-dialog-component';
import { RequisitionBuilderDialogComponent } from './components/requisition-builder-dialog/requisition-builder-dialog.component';
import { UploadReportDialogComponent } from './components/upload-report-dialog/upload-report-dialog.component';
export interface Requisition {

  id: number;

  patientId: number;

  doctorId: number;

  customerId?: number | null;

  patientName: string;

  patientLastName?: string;

  doctorName: string;

  mobileNumber: string;

  tests: string;

  status: string;

  date: string;

  comments: string;

  photoURL?: string;

  patientObject?: any;

  services?: any;

  url?: string;
}
@Component({
  selector: 'app-lab-dashboard',
  standalone: true,
  imports: [
    DashboardStatsComponent,
    RequisitionFilterComponent,
    RequisitionTableComponent,
    LabDashboardHeaderComponent,
    PatientSelectionDialogComponent,
    RequisitionBuilderDialogComponent


  ],
  templateUrl: './lab-dashboard.component.html',
  styleUrls: ['./lab-dashboard.component.scss']
})
export class LabDashboardComponent implements OnInit {

  loading = signal(false);

  requisitions: any = signal<Requisition[]>([]);

  stats = signal<DashboardStats>({
    total: 0,
    open: 0,
    confirmed: 0,
    pending: 0
  });

  filters = signal({
    search: '',
    fromDate: moment().subtract(7, 'days').toDate(),
    toDate: new Date()
  });

  constructor(
    private labService: LabmoduleService,
    private dialog: MatDialog, private authService: AuthService,
    public dialogRef: MatDialogRef<RequisitionBuilderDialogComponent>,
  ) { }

  ngOnInit(): void {
    this.loadRequisitions();
  }


  openPatientOnboard(): void {

    console.log('OPENING ONBOARD FROM PATIENT SELECTION');

    const dialogRef = this.dialog.open(PatientSelectionDialogComponent, {
      width: '500px',
      maxWidth: '95vw',
      panelClass: 'same-rmn-dialog'
    });

    dialogRef.afterClosed().subscribe((result: any) => {

      console.log(
        'AFTER CLOSED FIRED',
        result
      );

    });

  }

  loadRequisitions(): void {

    this.loading.set(true);

    const lab = JSON.parse(
      localStorage.getItem('LAB_DETAILS') || '{}'
    );

    const filter = this.filters();

    const payload = {

      labid: lab.id,

      fromdate: filter.search?.trim()
        ? '2000-01-01'
        : moment(filter.fromDate).format('YYYY-MM-DD'),

      todate: moment(filter.toDate).format('YYYY-MM-DD')
    };

    this.labService
      .getRequisitionsByLabId(payload)
      .subscribe({
        next: (response: any) => {

          let data = this.mapRequisitions(
            response.requisitions || []
          );

          // Local search
          if (filter.search?.trim()) {

            const search =
              filter.search.toLowerCase();

            data = data.filter(x =>
              (x.patientName || '')
                .toLowerCase()
                .includes(search) ||

              (x.doctorName || '')
                .toLowerCase()
                .includes(search) ||

              (x.mobileNumber || '')
                .toLowerCase()
                .includes(search) ||

              (x.patientId || '')
                .toString()
                .includes(search)
            );
          }

          this.requisitions.set(data);
          console.log("requisitions", data);


          this.calculateStats(data);

          this.loading.set(false);
        },
        error: () => {
          this.loading.set(false);
        }
      });
  }


  private mapRequisitions(data: any[]): Requisition[] {

    return data.map((item: any) => {

      // Get CustomerId from API response
      const rawCustomerId =
        item.CustomerId ??
        item.customerId ??
        item.Patient?.User?.CustomerId ??
        item.Patient?.User?.Customer?.id ??
        null;

      // Validate CustomerId
      // CustomerId = 1 is excluded temporarily
      // because it was incorrect in your test records.
      const customerId =
        rawCustomerId !== null &&
          rawCustomerId !== undefined &&
          Number.isSafeInteger(Number(rawCustomerId)) &&
          Number(rawCustomerId) > 1
          ? Number(rawCustomerId)
          : null;

      const patientId =
        item.PatientId ??
        item.patientId ??
        item.Patient?.id ??
        null;

      const doctorId =
        item.DoctorId ??
        item.doctorId ??
        item.Doctor?.id ??
        null;

      console.log('REQUISITION MAPPING:', {
        RequisitionId: item.id,
        DoctorId: doctorId,
        PatientId: patientId,
        BackendCustomerId: item.CustomerId,
        NestedCustomerId:
          item.Patient?.User?.Customer?.id,
        FinalCustomerId: customerId
      });

      return {

        id: item.id,

        patientId: patientId,

        doctorId: doctorId,

        customerId: customerId,

        patientName:
          `${item.Patient?.User?.first_name || ''} ${item.Patient?.User?.last_name || ''}`.trim(),

        patientLastName:
          item.Patient?.User?.last_name || '',

        doctorName:
          item.Doctor?.User?.first_name === 'SYSTEM'
            ? 'Self'
            : `${item.Doctor?.User?.first_name || ''} ${item.Doctor?.User?.last_name || ''}`.trim(),

        mobileNumber:
          item.Patient?.User?.phone_number || '',

        tests:
          item.tests || '',

        status:
          item.status || 'Open',

        date:
          item.createdAt,

        comments:
          item.labcomments || '',

        photoURL:
          item.photoURL,

        url:
          item.url,

        services:
          item.Doctor?.services,

        patientObject:
          item.Patient

      };

    });

  }

  private calculateStats(
    data: Requisition[]
  ): void {

    console.log(
      'calculateStats',
      data.map(x => x.status)
    );

    this.stats.set({

      total: data.length,

      open: data.filter(
        x =>
          !x.status ||
          x.status === 'Open'
      ).length,

      confirmed: data.filter(
        x =>
          x.status === 'Confirmed'
      ).length,

      pending: data.filter(
        x =>
          x.status === 'Sample collected'
      ).length

    });
  }

  onFilterChange(filters: any): void {

    this.filters.set(filters);

    this.loadRequisitions();
  }

  onUploadReport(row: Requisition): void {

    const doctorId = row.doctorId;
    const patientId = row.patientId;
    const customerId = row.customerId;

    console.log('UPLOAD CLICK - CHAT IDS:', {
      DoctorId: doctorId,
      PatientId: patientId,
      CustomerId: customerId
    });

    if (!doctorId || !patientId) {
      alert('DoctorId or PatientId is missing.');
      return;
    }

    // Do not block the normal lab report upload
    // when chat CustomerId is missing.
    if (!customerId || Number(customerId) <= 1) {
      console.warn(
        'CustomerId unavailable. Lab upload can proceed, but chat sending requires a valid CustomerId.'
      );
    }

    this.dialog.open(
      UploadReportDialogComponent,
      {
        width: '98vw',
        maxWidth: '1700px',
        height: '95vh',
        panelClass: 'upload-report-dialog',
        disableClose: true,
        data: {
          requisition: {
            ...row,
            doctorId,
            patientId,
            customerId
          }
        }
      }
    );

  }
  onStatusUpdate(row: Requisition): void {

    const dialogRef = this.dialog.open(
      StatusUpdateDialogComponent,
      {
        width: '700px',
        maxWidth: '95vw',
        panelClass: 'status-dialog-panel',
        data: {
          requisition: row
        }
      }
    );

    dialogRef.afterClosed()
      .subscribe((updated) => {

        if (updated) {

          this.loadRequisitions();

        }

      });
  }


  onCreateRequisition(row: Requisition): void {

    this.openRequisitionBuilder(row);

  }
  openCreateRequisition(): void {

    const dialogRef = this.dialog.open(
      PatientSelectionDialogComponent,
      {
        width: '1000px',
        maxWidth: '95vw',
        height: '85vh',
        autoFocus: false,
        disableClose: false,
        panelClass: 'patient-selection-dialog'
      }
    );

    dialogRef.afterClosed()
      .subscribe((result: any) => {

        console.log(
          'PATIENT SELECTION CLOSED',
          result
        );

        if (!result) {
          return;
        }

        // Open onboarding
        if (result.openOnboard) {

          const onboardRef =
            this.dialog.open(
              PatientOnboardDialogComponent,
              {
                width: '1100px',
                maxWidth: '95vw',
                height: '88vh',
                maxHeight: '88vh',
                panelClass: 'patient-onboard-dialog',
                autoFocus: false,
                disableClose: true
              }
            );

          onboardRef.afterClosed()
            .subscribe((onboardResult: any) => {

              console.log(
                'ONBOARD CLOSED',
                onboardResult
              );

              if (
                onboardResult?.openRequisition &&
                onboardResult?.patient
              ) {

                this.openRequisitionBuilder(
                  onboardResult.patient
                );

              }

            });

          return;
        }

        // Existing patient selected
        this.openRequisitionBuilder(
          result
        );

      });

  }
  openRequisitionBuilder(patient: any): void {

    console.log('OPENING REQUISITION BUILDER', patient);


    const dialogRef = this.dialog.open(
      RequisitionBuilderDialogComponent,
      {
        width: '65vw',
        // maxWidth: '1500px',

        height: '99vh',
        // maxHeight: '92vh',

        panelClass: 'requisition-dialog-panel',

        disableClose: false,
        autoFocus: false,

        data: {
          loading: this.loading,
          patient: patient
        }
      }
    );

    dialogRef.afterClosed().subscribe((result: any) => {

      console.log(
        'REQUISITION BUILDER CLOSED',
        result
      );

      if (result?.refresh) {
        this.loadRequisitions();
      }

    });
  }

  onPatientOnboarded(result: any): void {
    console.log(
      'PATIENT ONBOARDED EVENT',
      result
    );
    if (result?.refresh) {
      this.loadRequisitions();
    }
  }
  logout() {
    console.log("logut hittedd");

    localStorage.removeItem("lock");
    this.authService.deleteToken(0);
  }

}